import React, { useEffect, useState } from 'react';
import Box from '../common/Box';

import { toPercentTime } from '../../../common/utils/convertUtil';

export default function LiveChannelVirtual(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (props.type && props.type.toUpperCase() === '24TV') {
      setData([]);
    } else {
      setData(props.virtual);
    }
  }, [props]);

  const renderItems = (data, channelType = '') => {
    if (!data || data.length === 0) return <></>;
    return data.map((item, index) => {
      let percent = toPercentTime(item.starttime, item.endtime);
      let progress = {
        percent: percent,
        status: `${item.starttime}부터 ${item.endtime} 까지 방송예정, 현재 ${percent} 방송 중`
      }
      let channelName = (item.channelname === undefined || (item.channelid && item.channelid.indexOf('EVENT4') > -1)) ? 'SBS' : item.channelname;
      let ch_info = { title: item.title, desc: channelName }
      let label = [];
      let thumbnailImgUrl = item.thumbimg;
      thumbnailImgUrl = (thumbnailImgUrl === undefined) ? '/images/sbs.png' : thumbnailImgUrl;

      if (parseInt(item.target_age) >= 19) label.push({ type: '19' });
      if (item.channelid === 'S01' && item.channelname === 'SBS 카타르 2022' && props.data.filter(element => element.channelid === 'S01').length > 1) {
        return false;
      }


      return <li key={item.channelid} className="live_list_cont">
        <Box view={true} type="2" imageQuality={75} info={ch_info} img={thumbnailImgUrl} link={(item.channelid === 'EVENT4' && item.homeurl.length > 0) ? item.homeurl : `/live/${item.channelid}`} progress={progress} label={label} clickParams="div=live_list" />
      </li>
    })
  }

  return (
    <div className='contents_area_24tv'>
      <div className="module_titleline_w">
        <h3 className="module_titleline_title">24시간 TV</h3>
      </div>

      <div className='live_list_w'>
        <ul className="live_list_inner">
          {renderItems(data, props.type)}
        </ul>
      </div>
    </div>
  );
}
